<div id="talkjs-container" style="height: min(90vh, 675px)">{{ "__CONFERENCE_LOADING_CHATS__" | translate }}</div>
